import { createAxiosByInterceptors } from './axios'
import { getMpHost,getInterationHost } from './config'
import CookieUtil from '../../../utils/cookie'

const GETMPHOST = createAxiosByInterceptors({
    baseURL: getMpHost(),
})

const INTERATIONHOST = createAxiosByInterceptors({
    baseURL: getInterationHost(),
})

// 获取最热评论
export const getHottestComment = function (params) {
    return GETMPHOST.get('/wap/api/comments/hottest', { params: params })
}

/**
 * @description 获取评论列表
 * @param {{sourceId:String, pageNo:Number, pageSize:Number, type: Number, accountId:Number|String}} params 
 * sourceId: 格式为mp_文章id
 * pageNo： 分页页码
 * pageSize： 分页大小 
 * type：0按照热度排序，1按照最新排序
 * accountId：账号id
 * @returns 
 */
export const getComments = function (params) {
    return GETMPHOST.get('/wap/api/comments', { params: params })
}
// 获取文章是否禁言
export const fetchCommentStatus = function (params) {
    return GETMPHOST.get('/comment/api/topics', { params })
}

// 获取用户信息
export const getUserInfo = function () {
    const p = {
        appId: 100016,
        device: 'MPTCFEMOBILEUSER'
    }
    return GETMPHOST.get('/v3/uc/user/info', { params: p })
}
// 获取文章点赞数量
export const getLikeCount = function () {
    const p = {
        source_id: `mp_${window.cfgs?.newsId}`,
        visitorId: CookieUtil.get("SUV")
    }
    return GETMPHOST.get('/wap/api/topic/like/count', { params: p })
}
// 同步游客文章点赞
export const syncLikeArticle = () => {
    const params = {
        visitorId: CookieUtil.get("SUV")
    }
    return GETMPHOST.post('/wap/api/like/syncVisitor', params)
}
// 点赞
export const handleLike = function (flag) {
    const params = {
        source_id: `mp_${window.cfgs?.newsId}`,
        is_like: flag,
        visitorId: CookieUtil.get("SUV")
    }
    return GETMPHOST.post('/wap/api/topic/like', params,{
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// 收藏
export const sendCollection = function (flag) {
    let status = flag ? 1 : 0
    const params = {
        sourceId: `mp_${window.cfgs?.newsId}`,
        displayStatus: status,
        topicLink: window?.location?.origin + window?.location?.pathname,
        topicTitle: window?.cfgs?.title
    }
    return GETMPHOST.post('/wap/collect/', params)
}

// 获取互动数量
export const getInteractionCountApi = function () {
    const params = {
        sourceId: `mp_${window.cfgs?.newsId}`
    }
    return GETMPHOST.get('/wap/api/static/topic', { 
        params,
        headers: {
            'visitorid': CookieUtil?.get("SUV")
        }
     },
    )
}

// 点赞-未登录环境
export const handleLikeUnlogin = function (flag) {
    const params = {
        source_id: `mp_${window.cfgs?.newsId}`,
        is_like: flag
    }
    return GETMPHOST.post('/wap/api/topic/like/count', params,
    {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}
// 获取文章评论数量
export const getCommentCount = function () {
    const p = {
        sourceId: `mp_${window.cfgs?.newsId}`,
        pageNo: 1,
        pageSize: 1,
        type: 0
    }
    return GETMPHOST.get('/wap/api/comments', { params: p })
}

// 发评论
export const publishComment = function ({ content, attachmentUrls } = {}) {
    const params =  {
        source_id: `mp_${window.cfgs?.newsId}`,
        topic_url: `${window.location.origin}${window.location.pathname}`,
        topic_title: document?.title,
        channel_id: window.cfgs?.channelId,
        media_id: window.cfgs?.media_id,
        reply_id: 0,
        content: content,
        attachment_urls: attachmentUrls,
    }
    return INTERATIONHOST.post('/api/comments/', params,{
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}